interface FooterProps {
  onOpenApprovalModal: () => void;
}

export default function Footer({ onOpenApprovalModal }: FooterProps) {
  return (
    <footer className="bg-primary-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b4573abb41861ee3e1a13dce7bef25dc.jpeg"
                alt="Smart Hizmet Logo"
                className="w-9 h-9 rounded-lg object-cover"
              />
              <span className="font-heading font-bold text-background-50 text-lg">Smart Hizmet</span>
            </div>
            <p className="text-background-50/60 text-sm leading-relaxed">
              Davranış Analizi Destekli Reklam ve Müşteri Takip Sistemi. Reklamdan gelen kişileri daha doğru analiz etmek, satışa yakın başvuruları ayırmak ve reklam sürecini daha ölçülebilir hale getirmek için geliştirilmiş özel sistem.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm uppercase tracking-wider mb-4">
              Hızlı Bağlantılar
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Sistem Nasıl Çalışır', id: 'nasil-calisir' },
                { label: 'Neler Dahil', id: 'neler-dahil' },
                { label: 'Fiyatlandırma', id: 'fiyat' },
                { label: 'Senaryolar', id: 'senaryolar' },
                { label: 'Form', id: 'form' },
              ].map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-background-50/60 text-sm hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm uppercase tracking-wider mb-4">
              İletişim
            </h4>
            <button
              type="button"
              onClick={onOpenApprovalModal}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap mb-4"
            >
              <i className="ri-whatsapp-line"></i>
              Uygundur Yaz
            </button>
            <p className="text-background-50/50 text-xs mt-2">
              WhatsApp üzerinden ulaşabilirsiniz.
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} Smart Hizmet. Tüm hakları saklıdır.
          </p>
          <p className="text-background-50/40 text-xs">
            Smart Hizmet - Davranış Analizi Destekli Reklam ve Müşteri Takip Sistemi
          </p>
        </div>
      </div>
    </footer>
  );
}